<template>
  <el-container class="module-container social-module">
    <el-main class="social-module__main">
      <el-tabs v-model="activeTab"
               class="module-container__header-tab">
        <el-tab-pane
          :lazy="true"
          :label="$t('Top Scores')">
          <MyFeed :project-id="projectId" :top-scores="true" />
        </el-tab-pane>
        <el-tab-pane
          :lazy="true"
          :label="$t('My Feed')">
          <el-row class="social-main">
            <el-col :span="16" :xs="24">
              <MyFeed :project-id="projectId" />
            </el-col>
            <el-col :span="8" class="recentActivity-mobile">
              <RecentActivity :project-id="projectId" />
            </el-col>
          </el-row>
        </el-tab-pane>
        <template v-if="tabHide">
          <el-tab-pane
            :lazy="true"
            :label="$t('Recent Activity')">
            <RecentActivity :project-id="projectId" />
          </el-tab-pane>
        </template>
      </el-tabs>
    </el-main>
  </el-container>
</template>

<script>
import RecentActivity from './components/RecentActivity';
import MyFeed from './components/MyFeed';

export default {
  name: 'Social',
  components: {
    RecentActivity,
    MyFeed
  },
  props: {
    projectId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      activeTab: 0,
      tabHide: false
    };
  },
  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.widthPage = window.innerWidth;
      if (window.innerWidth < 800) {
        this.tabHide = true;
      } else {
        this.tabHide = false;
      }
    }
  }
};
</script>

<style lang="scss">
.social-main {
  display: flex;
  justify-content: space-between;
}

.social-module {
  &__main {
    padding: 0;
  }
}

.module-container__header-tab.el-tabs > .el-tabs__content {
  padding: 20px 20px 20px 40px;
}

@include breakpoint(md-max) {
  .social-main {
    display: flex;
    flex-direction: column;
    padding: 10px;
    margin: unset;
  }

  .recentActivity-mobile {
    display: none;
  }

  .module-container__header-tab.el-tabs > .el-tabs__content {
    padding: unset;
  }
}
</style>
